module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!(_vm.$route.path === '/')),
      expression: "!($route.path==='/' )"
    }],
    staticClass: "header"
  }, [_c('div', {
    staticClass: "status-bar"
  }, [_c('span', {
    staticClass: "status-bar__location"
  }, [_c('span', {
    staticClass: "status-bar__info"
  }, [_vm._v(_vm._s(_vm.location.location))])]), _vm._v(" "), _c('span', {
    staticClass: "status-bar__credits"
  }, [_c('span', {
    staticClass: "status-bar__info"
  }, [_vm._v("credits ")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-volume-up"
  }), _vm._v(" \n\t\t\t" + _vm._s(_vm.credits) + "\n\t\t")])]), _vm._v(" "), _c('nav', {
    staticClass: "menu"
  }, [_c('router-link', {
    staticClass: "menu__entry",
    attrs: {
      "to": "/profile",
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" "), _c('span', [_vm._v("Profil")])]), _vm._v(" "), _c('router-link', {
    staticClass: "menu__entry",
    attrs: {
      "to": "/charts",
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-line-chart"
  }), _vm._v(" "), _c('span', [_vm._v("Charts")])]), _vm._v(" "), _c('router-link', {
    staticClass: "menu__entry",
    attrs: {
      "to": "/search",
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-search-plus"
  }), _vm._v(" "), _c('span', [_vm._v("Vorschlagen")])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2328522c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = 211
// module chunks = 1